import { render } from "./ProjectListItem.vue?vue&type=template&id=0f38d0ae&scoped=true"
import script from "./ProjectListItem.vue?vue&type=script&lang=js"
export * from "./ProjectListItem.vue?vue&type=script&lang=js"

import "./ProjectListItem.vue?vue&type=style&index=0&id=0f38d0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f38d0ae"]])

export default __exports__